import * as React from 'react';
import { FormControl,Grid, Button, FormLabel} from '@mui/material';
import { markedAsCryopreserveLSM,addCryoPData,printCryoPData } from "../../../../../bmr/slices/manufacturer";
import {  selectStorageLocationDropdown, fetchStorageLocationDropDown } from "../../../../../bmr/slices/storageLocation";
import { useDispatch, useSelector } from "react-redux";
import { cryoInitialsValue} from "../../../../../utils/formik/initialValues"
import { cryoValidationSchema} from "../../../../../utils/formik/validationSchema"
import { useFormik } from "formik";
import FormikArrayPreScreen from "../../../../../pages/appointment-details/common-pre-screen/FormikArrayPreScreen"
import FormikControl from "../../../../../bmr/components/common/FormikControl";
import { selectCurrentCycle } from "../../../../../bmr/slices/common";
import { notify } from '../../../../utils/methods/notification';
import { selectDynamicBags,volumnBagList } from "../../../../../bmr/slices/manufacturer"; 
const CryoLsmFormDialog = ({ showLsm=true, formProps, setOpen,getTimeLine, onReprint }) => {
    const dispatch = useDispatch()
    const storageLocationDropdown = useSelector(selectStorageLocationDropdown)
    const currentCycle = useSelector(selectCurrentCycle)
    
    const bagDynamic = useSelector(selectDynamicBags)
    const [disabledAll,setDisabledAll] = React.useState(false)
    const [showBtn, setShowBtn] = React.useState(true)

    React.useEffect(() => {
        const total_blood = bagDynamic?.reduce((sum, bag) => sum + (Number(bag?.cd3_count) || 0),0);
        const remaining_blood = Number(currentCycle?.remaining_blood) || 0;
        const shouldShow =
          (remaining_blood !== 0 || total_blood < remaining_blood) && currentCycle?.status != 2 && currentCycle?.status != '0';
        setShowBtn(shouldShow);
    }, [ bagDynamic, currentCycle?.remaining_blood, currentCycle?.status]);

    const handleStorage = async() => {
      await dispatch(fetchStorageLocationDropDown())
    }

    React.useEffect(() =>{
       handleStorage()        
    },[])
        const handleCryopreserved = async (values) => {
        try {

        const totalVolume = values?.blood_bags?.reduce(
          (sum, bag) => sum + (parseFloat(bag?.cd3_count) || 0),
          0
        );
       if(totalVolume > parseFloat(currentCycle?.remaining_blood)){
        notify.error('Total CD3+ count of all bags must be less than total toal')
        return false
       }    

       if(totalVolume < parseFloat(currentCycle?.remaining_blood)){
        notify.error('Total CD3+ count across all bags cannot be less than the total')
        return false
       }
        delete values?.total_lsm
            // Prepare API payload with the selected restart option
            const payload = {
                data: values,
                subject_id: formProps?.subject_id,
                inbound_patient_id: formProps?.inbound_patient_id,
            }

            const res = await dispatch(markedAsCryopreserveLSM(payload)).unwrap();
            if (res?.status === 200) {
                setOpen?.(false)
                getTimeLine(formProps?.subject_id)
            }
        } catch (err) {
            console.error("Error LSM Approval:", err);
        }
    }


       const handleCryoLsmForm = async (values) => {
        try {

      
           let finalValue = values?.blood_bags;
          if(bagDynamic && bagDynamic?.length > 0){
             finalValue = finalValue?.filter(
              item => !bagDynamic.some(
                dyn => String(dyn.identifier) === String(item.identifier)
              )
            );
          }

        const totalVolume = finalValue?.reduce(
          (sum, bag) => sum + (parseFloat(bag?.cd3_count) || 0),
          0
        );

       if(totalVolume > parseFloat(currentCycle?.remaining_blood)){
        notify.error('Total volume of all bags must be less than total blood')
        return false
       } 

            // Prepare API payload with the selected restart option
            const payload = {
                ...values,
                blood_bags:finalValue,
                feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
                product_manufacturing_id: currentCycle?.product_manufacturing_id,        
            }

            const res = await dispatch(addCryoPData({data:payload})).unwrap();
            if (res?.status === 200) {
                getTimeLine(formProps?.subject_id)
            }
        } catch (err) {
            console.error("Error LSM Approval:", err);
        }
    }

    React.useEffect(()=>{
   if(bagDynamic?.length > 0)
     setDisabledAll(true)
    },[bagDynamic])
const initialValues = React.useMemo(() => ({
  ...cryoInitialsValue,
  total_lsm: currentCycle?.remaining_blood ?? "",

  blood_bags: Array.isArray(bagDynamic) && bagDynamic.length > 0
    ? bagDynamic.map((bag) => ({
        identifier: bag?.identifier, // or Number(bag.identifier)
        volume: bag.volume ?? "",
        cd3_count: bag.cd3_count ?? "",
        print_count: bag.print_count ?? 0,
        storage_location_id: bag?.storage_location?.id ?? "",
      }))
    : cryoInitialsValue.blood_bags,
}), [currentCycle?.remaining_blood, bagDynamic]);

    const formik = useFormik({
    initialValues: initialValues,   
    validateOnBlur: false,
    validationSchema: cryoValidationSchema,
    enableReinitialize: true,
    onSubmit: !showLsm ? handleCryoLsmForm : handleCryopreserved,
    });

const formOptions = React.useMemo(() => ([
      ...showLsm ? [{
            label: "Total CD3+ Count For Cryopreserve",
            type: "number",
            name: "total_lsm",
            placeholder: "Enter CD3+ Count",
            disabled: true,
            extraContent:"x10⁶ Cells",
            required: true,
            col: 1
      }]:[],
      {
      label: showLsm ? "Required Cryopreserved LSM":"",
       type: "text",
      name: "blood_bags",
      required: true,
      initialChildrenData: { identifier: formik?.values?.blood_bags?.length+1, volume: 100, cd3_count: "",print_count:0,storage_location_id:"" },
      multipleField: true,
      col: 4,
      object:true,
      extraContent:"ml",
      children: (index) => [
        {
            label: "No. Of Bag",
            type: "number",
            name: `blood_bags.${index}.identifier`,
            placeholder: "Enter number of bags",
            disabled: true,
            extraNote: bagDynamic?.[index]?.status == 1 ? 'Bag utilized for '+ bagDynamic?.[index]?.cycle_no:'',
            noQuery:true,
            required:true,
        },
        {
                label: "CD3+ In Each Bag",
                type: "number",
                name: `blood_bags.${index}.cd3_count`,
                placeholder: "Enter CD3+",
                required: true,
                noQuery:true,
                extraContent:"x10⁶ Cells",
                disabled:disabledAll ? bagDynamic?.some(
                (it) =>
                  String(it?.identifier) ===
                    String(formik?.values?.blood_bags?.[index]?.identifier) &&
                  Number(it?.cd3_count) ===
                    Number(formik?.values?.blood_bags?.[index]?.cd3_count)
              ) :false 
        },
        /*{
                label: "Volume In Bag",
                type: "number",
                name: `blood_bags.${index}.volume`,
                placeholder: "Enter Volume",
                required: true,
                noQuery:true,
                extraContent:"ml",
                disabled: true
        },*/
        {
            label: "Storage Location",
            type: "select",
            options: storageLocationDropdown,
            name:  `blood_bags.${index}.storage_location_id`,
            placeholder: "Enter Storage Location",
            required: true,
            noQuery:true,
            disabled:disabledAll ? bagDynamic?.some(
                (it) =>
                  String(it?.identifier) ===
                    String(formik?.values?.blood_bags?.[index]?.identifier) &&
                  Number(it?.storage_location?.id) ===
                    Number(formik?.values?.blood_bags?.[index]?.storage_location_id)
              ) :false
        },
        {
                label: "Print Count",
                type: "number",
                name: `blood_bags.${index}.print_count`,
                placeholder: "Print Count",
                 noQuery:true,
                disabled: true
        },
      ],
    }
    ]), [
    showLsm,
    bagDynamic,        
    disabledAll,
    storageLocationDropdown,
    formik?.values?.blood_bags,
  ]);

  const updatePrintCount = async(id,index) => {
    try{
     const payload = {id}
            const res = await dispatch(printCryoPData(payload)).unwrap();
            if (res?.status === 200) {
               await dispatch(volumnBagList(currentCycle?.feasibility_assessments_id)).unwrap();
               onReprint(index)
            }
        } catch (err) {
           notify.error('Unable to Print, Please try in sometime.')
        }
      }
  const handleRprint= (index) => {
    updatePrintCount(bagDynamic?.[index]?.id,index)
  }
console.log(bagDynamic)
    return (
        <div className="w-full flex flex-col">
           <form className="p-3" onSubmit={formik.handleSubmit}>
             {formOptions?.map((props, key) => (
               <Grid
                      key={'_manual_'+key}
                      item
                      xs={props.col && !props?.object ? 12 / props.col : 12}
                      className={`pt-2 ${props?.object ? 'flex':''}`}
                    >

                    {!props?.object ? <>
                     <FormControl key={'_control_'+key} variant={props.variant ?? "standard"} fullWidth={props.fullWidth ?? true} > 
                    {/* Field labels */} 
                    {props.label && props.children && ( <FormLabel shrink required={props.required} className="text-[black]" > {props.label} </FormLabel> )} 
                    <div className="relative" key={key}> <FormikControl formik={formik} {...props} className="mt-2" key={'_props_'+key} /> </div> </FormControl>
                     </>:
                      <FormControl
                        variant={props.variant ?? "standard"}
                        fullWidth={props.fullWidth ?? true}
                        className={`pr-3 ${props.section ? "pt-3" : ""} ${props.className ?? ""
                          }`}
                      >
                        {props.label && (
                          <FormLabel
                            shrink
                            required={props.required}
                            className="text-[black]"
                          >
                            {props.label}
                          </FormLabel>
                        )}
                        <FormikArrayPreScreen
                              props={props}
                              formik={formik}
                              specialCaseAdd={showBtn}
                              disabledAll={disabledAll}
                              buttonPermission={disabledAll}
                              showDeleteButton={!disabledAll}
                              showPrintButton={bagDynamic?.length > 0}
                              onReprint={handleRprint}
                            />
                        </FormControl>}
            </Grid>))}
            {showBtn && <Button type="submit" variant="contained" className="w-[200px] h-[40px]">Submit</Button>}
            </form>
        </div>
    );
}
export default CryoLsmFormDialog;